export default {
  data() {
    return {
      linkedInternalDocuments: [],
    };
  },
  methods: {
    onLinkedInternalDocuments(documents) {
      this.linkedInternalDocuments = documents;
    },
  },
};
